import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { useAuth } from "../contexts/AuthContext";
import "../styles/Login.css";

import { auth, provider, signInWithPopup } from "../firebase";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("error"); // "error" o "success"
  const { login } = useAuth();
  const navigate = useNavigate();

  const showErrorToast = (message) => {
    setError(message);
    setToastType("error");
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const showSuccessToast = (message) => {
    setError(message);
    setToastType("success");
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };
  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        login({
          ...data.user,
          token: data.token,
          refresh_token: data.refresh_token,
        });
        showSuccessToast("Inicio de sesión exitoso");
        setTimeout(() => navigate("/"), 1000); // navegación suave tras mostrar el mensaje
      } else {
        showErrorToast(data.message || data.error || "Error al iniciar sesión");
      }
    } catch (error) {
      console.error("Error de conexión:", error);
      showErrorToast("No se pudo conectar al servidor");
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Si deseas enviar este usuario a tu backend:
      const payload = {
        email: user.email,
        nombre: user.displayName,
        firebase_uid: user.uid,
      };

      const response = await fetch(`${API_BASE_URL}/auth/login_google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.ok) {
        login({ ...data.user, token: data.token });
        navigate("/");
      } else {
        alert(data.error || "Error con login de Google");
      }
    } catch (error) {
      console.error("Error con Google login:", error);
    }
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Iniciar sesión</h2>
      <input
        type="email"
        placeholder="Correo electrónico"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="form-input"
      />
      <input
        type="password"
        placeholder="Contraseña"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="form-input"
      />
      <button onClick={handleLogin} className="form-button">
        Ingresar
      </button>

      <p className="forgot-text">
        <Link to="/recuperar">¿Olvidaste tu contraseña?</Link>
      </p>

      <p className="register-text">
        ¿No tienes cuenta? <Link to="/register">Regístrate aquí</Link>
      </p>

      {showToast && (
        <div className={`toast toast-${toastType} show`}>
          {error}
        </div>
      )}
    </div>
  );
};

export default Login;
